<template lang="html">

	<section class="ficha -empresa">
		
		<template v-if="!!data">

			<h2 class="ficha-title" :style="styles.colorBasic">Empresa</h2>

			<article class="group">

				<h3 class="group-title" :style="styles.colorBasic">Datos de la empresa</h3>

				<div class="contenedor-data" v-if="!!data.cif">
					<h4 class="data-title" :style="styles.colorBasic">CIF</h4>
					<p>{{data.cif}}</p>
				</div>

				<div class="contenedor-data" v-if="!!data.nombreComercial">
					<h4 class="data-title" :style="styles.colorBasic">Nombre comercial</h4>
					<p>{{data.nombreComercial}}</p>
				</div>

				<div class="contenedor-data" v-if="!!data.sector">
					<h4 class="data-title" :style="styles.colorBasic">Sector</h4>
					<p>{{data.sector}}</p>
				</div>
		

				<div class="contenedor-data" v-if="!!data.direccion">
					<h4 class="data-title" :style="styles.colorBasic">Dirección</h4>
					<p>{{data.direccion}}</p>
				</div>


				<div class="contenedor-data" v-if="!!data.localidad">
					<h4 class="data-title" :style="styles.colorBasic">Localidad</h4>
					<p>{{data.localidad}}</p>
				</div>


				<div class="contenedor-data" v-if="!!data.provincia">
					<h4 class="data-title" :style="styles.colorBasic">Provincia</h4>
					<p>{{data.provincia}}</p>
				</div>

				<div class="contenedor-data" v-if="!!data.cp">
					<h4 class="data-title" :style="styles.colorBasic">Código Postal</h4>
					<p>{{data.cp}}</p>
				</div>

				<div class="contenedor-data" v-if="!!data.paisDescripcion">
					<h4 class="data-title" :style="styles.colorBasic">País</h4>
					<p>{{data.paisDescripcion}}</p>
				</div>

				<div class="contenedor-data" v-if="!!data.web">
					<h4 class="data-title" :style="styles.colorBasic">Web de la empresa</h4>
					<p><a :href="data.web" target="_blank">{{data.web}}</a></p>
				</div>


				<div class="contenedor-data -full" v-if="!!data.descripcion">
					<h4 class="data-title" :style="styles.colorBasic">Descripción</h4>
					<p>{{data.descripcion}}</p>
				</div>
				
			</article>

			<article class="group" v-if="!!contactos && !!!brand.hideContactosEmpresa">

				<h3 class="group-title" :style="styles.colorBasic">Contactos de la empresa</h3>

					<template v-for="contacto in contactos">
					
					<div class="subgroup row-start">

						<div class="contenedor-data" v-if="contacto.nombre">
							<h4 class="data-title" :style="styles.colorBasic">Nombre y apellidos</h4>
							<p>{{contacto.nombre}} {{contacto.apellidos}}</p>
						</div>

						<div class="contenedor-data" v-if="contacto.puesto">
							<h4 class="data-title" :style="styles.colorBasic">Puesto</h4>
							<p>{{contacto.puesto}}</p>
						</div>

						<div class="contenedor-data" v-if="contacto.telefono1">
							<h4 class="data-title" :style="styles.colorBasic">Teléfono</h4>
							<p><a :href="'tel:'+contacto.telefono1">{{contacto.telefono1}}</a></p>
						</div>

							<div class="contenedor-data" v-if="contacto.email">
							<h4 class="data-title" :style="styles.colorBasic">Email</h4>
							<p><a :href="'mailto:'+contacto.email">{{contacto.email}}</a></p>
						</div>

					</div>

				</template>



			</article>

		</template>

	</section>

</template>

<script lang="js">

	import {mapGetters, mapActions} from 'vuex';

	import onlyArrow  from '@/components/parts/icons/only-arrow';
	import arrowlink  from '@/components/parts/icons/arrow-link';

	export default  {
		name: 'ficha-empresa',
		props : ['data','contactos'],
		computed :{
			...mapGetters({
				styles : 'getStyles',
				brand : 'getBrand'
			})
		},
		components : {
			'only-arrow' : onlyArrow,
			'arrow-link' : arrowlink,
		}

	}
</script>

<style scoped lang="scss">
	.ficha-empresa {

	}
</style>



// WEBPACK FOOTER //
// src/components/views/ficha-empresa.vue